export const CardIds = {
    SHOPIFY_PERFORMANCE_SUMMARY: 'crd_74b40b2c',
    FACEBOOK_CPA_SUMMARY: 'crd_4be6d3a4',
    GA4_TRAFFIC_PERFORMANCE_SUMMARY: 'crd_a67eb131',
    // SHOPIFY_PERFORMANCE_SUMMARY: 54987,
    // FACEBOOK_CPA_SUMMARY: 55324,
};
